<template>
  <b-card no-body>
    <b-card-header>
      <h4>{{ $t('bookings.price_offers.send_price') }}</h4>
    </b-card-header>

    <b-card-body>
      <b-form-group
        v-if="showCompaniesList"
        :label="$t('bookings.price_offers.company')"
      >
        <b-select :options="companiesOptions" v-model="company" />
      </b-form-group>

      <b-input-group
        :prepend="currencyLabel"
        :label="$t('bookings.price_offers.price')"
      >
        <b-form-input v-model="price" :min="1"></b-form-input>
        <b-input-group-append>
          <b-button type="button" variant="primary" size="sm" @click="onSend">
            {{ $t('bookings.price_offers.send_price') }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'PriceOfferForm',
  props: {
    currencyLabel: {
      type: String,
      required: true,
    },
    companies: {
      type: Array,
      required: false,
      default: function() {
        return []
      },
    },
  },

  data() {
    return {
      price: null,
      company: null,
    }
  },

  computed: {
    showCompaniesList() {
      return this.$allows('administer')
    },

    companiesOptions() {
      return this.companies.map(company => {
        return {
          text: company.name,
          value: company.id,
        }
      })
    },
  },

  methods: {
    onSend() {
      this.$emit('send', { price: this.price, company_id: this.company })
    },
  },
}
</script>
